module.exports = __webpack_public_path__ + "img/school_mdhxzx.f30e2e90.png";